export default "__VITE_ASSET__CQwpEM53__"